import { NetworkOps } from '@activehub/common-components-spa-resource'
import { catchError, tap } from "rxjs/operators";
import { of, throwError, Observable } from "rxjs";
// Session ID stored in memory
let currentSessionId = null;
export const userLocale = navigator.language || 'en-US';
let environment = ['dev', 'qa', 'stg', 'perf']
let gethostname = window.location.hostname.split(".")[0];
let nullProxyBaseUrl = environment.includes(gethostname) ? `https://${gethostname}.ggw.ift.pearson-intl.com` : 'https://ggw.ift.pearson-intl.com';
let baseURL = (sessionStorage.getItem('proxyBaseUrl') != null) ? sessionStorage.getItem('proxyBaseUrl') : nullProxyBaseUrl;
const permissionAPI = new NetworkOps({
    baseURL: `/api/activehub-node/permission/v1`
})

const userAbilityAPI = new NetworkOps({
    baseURL: `/api/activehub-node`
})

export const rootAPI = new NetworkOps({
    baseURL: 'https://stg.ggw.ift.pearson-intl.com/api'
});

export const singleUserAddServicesApi = new NetworkOps({
  baseURL: '/api/activehub-node/bulkuserprocess/v2'
});

export const rootAPIV1 = new NetworkOps({
    baseURL: 'https://stg.ggw.ift.pearson-intl.com/api'
});

export const proxyAPI = new NetworkOps({
    baseURL: `/api/activehub-node/proxy/v1`
});

export const proxyAPIV2 = new NetworkOps({
    baseURL: `/api/activehub-node/proxy/v2`
});

export const gatewayConfigurationApi = new NetworkOps({
    baseURL: `/api/activehub-node/configuration/v1`,
});

export const notificationApi = new NetworkOps({
    baseURL: `/api/activehub-node/notification/v1`,
});

export const productAPI = new NetworkOps({
    baseURL: `/api/activehub-node/prdmgmtresource/v1`
});

export const bulkAccessCodeAPI = new NetworkOps({
    baseURL: `/api/activehub-node/entitlementaccesscodes/v3`
})

export function setSessionIdHeader(sessionId) {
     currentSessionId = sessionId;
    // Expose the sessionId to micro-frontend child SPAs (lesson-plan, student-home)
    window.GATEWAY = Object.assign(window.GATEWAY || {}, { sessionId });
    rootAPI.setSessionId(sessionId);
    rootAPIV1.setSessionId(sessionId);
    permissionAPI.setSessionId(sessionId);
    userAbilityAPI.setSessionId(sessionId);
    proxyAPI.setSessionId(sessionId);
    proxyAPIV2.setSessionId(sessionId);
    gatewayConfigurationApi.setSessionId(sessionId);
    notificationApi.setSessionId(sessionId);
    productAPI.setSessionId(sessionId);
    bulkAccessCodeAPI.setSessionId(sessionId);
    singleUserAddServicesApi.setSessionId(sessionId);
}

/* whenever a new networkOps is defined add it in setAuthToken and setUserIdHeader */
export function setAuthToken(token) {
    rootAPI.setAuthToken(token);
    rootAPIV1.setAuthToken(token);
    permissionAPI.setAuthToken(token);
    userAbilityAPI.setAuthToken(token);
    proxyAPI.setAuthToken(token);
    proxyAPIV2.setAuthToken(token);
    gatewayConfigurationApi.setAuthToken(token);
    notificationApi.setAuthToken(token);
    productAPI.setAuthToken(token);
    bulkAccessCodeAPI.setAuthToken(token);
    singleUserAddServicesApi.setAuthToken(token);
}

export function setUserIdHeader(id) {
    rootAPI.setUserId(id);
    rootAPIV1.setUserId(id);
    permissionAPI.setUserId(id);
    userAbilityAPI.setUserId(id);
    proxyAPI.setUserId(id);
    proxyAPIV2.setUserId(id);
    gatewayConfigurationApi.setUserId(id);
    notificationApi.setUserId(id);
    productAPI.setUserId(id);
    bulkAccessCodeAPI.setUserId(id);
    singleUserAddServicesApi.setUserId(id);
}

// export function setPmrIdHeader(pmrId) {
//   userAbilityAPI.setPmrId(pmrId);
// }

export function getUserProfile(userId) {
    return userAbilityAPI.get(`/user/v1/user/${userId}`);
}
/**
 * Update the user profile
 * @param userId 
 * @param data 
 */
export function updateUserProfile(userId, data) {
    return userAbilityAPI
        .patch(`/user/v1/user/${userId}/profile`, data);
}

/**
 * Getting the Role of the user
 * @param data 
 * @param token 
 */

export function getIsbnCode(isbn, pageNumber, pageSize) {
    return bulkAccessCodeAPI.get(`/accesscode/search/isbn/${isbn}?page=${pageNumber}&size=${pageSize}`);
}
export function getProductMetadata(isbn) {
    return productAPI.get(`/product/isbn/${isbn}`);
}
export function getBulkAccessCode(pmrid,payload,){
    return bulkAccessCodeAPI.post(`/accesscode/productModelRegion/${pmrid}/generate`,payload)
}
export function downloadCode(requestid){
    return bulkAccessCodeAPI.get(`/access-codes/${requestid}/download`)
}
export function emailCode(payload){
    return bulkAccessCodeAPI.post(`/accessCodes/sendMail`, payload)
}
export function getAccessCodeIsbn (isbn){
    return bulkAccessCodeAPI.get(`/accesscode/search/isbn/${isbn}`);
}
export function getUserRole(data) {
    return userAbilityAPI
        .post('/usersearch/v1/search/users', data);
}

export function getUserAbilities(userId, regionId) {
    return proxyAPI.get(`/getUserAbilityByUserIdRegionId/${userId}/${regionId}`)
}
export function getSPAsInRegion(region, locale = userLocale) {
    return proxyAPI.get(`/getSPAInRegion/${region}/locale/${locale}`)
}

export function getHeaderInfo() {
    let hostinfo = window.location.host.includes("qa.") ? window.location.host.replace("qa.", "stg.") : window.location.host;
    return gatewayConfigurationApi.get(
        `/configuration/findByHostname/${hostinfo}/locale/${userLocale}`);
}

export function getCombinedProxyData(userId, pmrId, regionId, locale = userLocale) {
   const cacheKey = `combinedProxyData_${userId}_${pmrId}`;
  /*   const cached = sessionStorage.getItem(cacheKey); // to dsiable the browser caching
    if (cached) {
        return of(JSON.parse(cached));
    } */
    return proxyAPI.get(`/combined/user/${userId}/pmr/${pmrId}`).pipe(
        tap(response => {
            if (response) {
                sessionStorage.setItem(cacheKey, JSON.stringify(response));
            }
        })
    );
}

export function getNotifications() {
    return notificationApi.get(`/inappnotifications/unread`);
}

export function readNotification(noId) {
    return notificationApi.put(`/inappnotification/${noId}/read`);
}

export function getAccessCodeData(data) {
    return proxyAPI.get(`/validateAccessCode/${data}`);
}

export function registerAccessCode(postData, accessCode) {
    return proxyAPI.post(`/registerAccessCode/${accessCode}`, postData);
}

export function getUserStatus(pmrIds) {
    return proxyAPI.post(`/getUserStatus`, pmrIds);
}

export function getOrgDetailsByUserV2(userId) {
    return proxyAPIV2.get(`/organisationDetailsForUser/user/${userId}/locale/en-GB`);
}

export function getAppcuesConfig() {
    return rootAPI.get(`/getAppcuesConfig`)
}

export function getTierInformation() {
    return proxyAPI.get(`/getTierData`)
}

export function getPreviewLiveStatus(pmrId, orgId, isPPID) {
    return proxyAPI.get(`/previewLiveStatus/pmr/${pmrId}/organization/${orgId}/${isPPID}`)
}

export function makeCourseLive(pmrId, orgId, payload) {
    return proxyAPI.put(`/previewLiveStatus/pmr/${pmrId}/organization/${orgId}`, payload)
}

export function getPearsonAdmin(pmrId, userId) {
    return proxyAPI.get(`/previewLiveStatus/pmr/${pmrId}/userId/${userId}`)
}

export function getUserPlatform() {
    console.log("calling platform endpoint...")
    return proxyAPI.get(`/getUserPlatformAccess`)
}

export function getAppdrawer(userId) {
    return proxyAPI.get(`/getAppdrawerList/userId/${userId}/local/en-US`)
}

export function getAppStatus() {
    return proxyAPI.get(`/getAppStatus`);
}
export function getAccessCodeValidate(accessCode) {
    return userAbilityAPI.get(`/entitlementaccesscodes/v2/accesscode/${accessCode}`)
}

export function activateAccessCode(accessCode, userId, orgId) {
    return rootAPI.post(`/prdmgmtsubscription/v3/subscription/user/${userId}/accesscode/${accessCode}`, {
        userId: [userId],
        organizationId: orgId,
        lob: "AH"
    })
} 

export function addNewUserToD2C(postData, prmId, d2cOrg) {
  return singleUserAddServicesApi.post(`/bulkuser/createandregister/${d2cOrg}/${prmId}`, postData)
}

export function accessCodeRedeemption(accessCode, payload) {
    return proxyAPI.post(`/redeemAccessCode/${accessCode}`, payload);
}

export function searchUsersV2(queryParams, data) {
  return proxyAPI.post(`/searchUsers${queryParams?`?${queryParams}`:''}`, data).pipe(
    catchError(err =>
      err && err.status === 404 ? of(null) : throwError(err)
    )
  );
}
 
export function searchUserByUserName(userName) {
  return proxyAPI.post(`/searchByusername`, { userName })
}

export function updateLastLogin(orgId, userId, payload) {
    return proxyAPI.patch(`/organization/${orgId}/user/${userId}/lastLoginDate`, payload);
}

export function sessionLoginApi(payload, token, userId) {
    return new Observable(subscriber => {
        fetch('/api/activehub-node/session', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token,
                'x-prsn-user-id': userId
            },
            credentials: 'include',
            body: JSON.stringify(payload)
        })
        .then(res => res.json())
        .then(data => {
            if (data.sessionId) {
                window.GATEWAY = Object.assign(window.GATEWAY || {}, { sessionId: data.sessionId });
                setSessionIdHeader(data.sessionId);
            }
            subscriber.next(data);
            subscriber.complete();
        })
        .catch(err => {
            subscriber.error(err);
        });
    });
}

export function getSessionId() {
    return currentSessionId;
}

export function sessionLogoutApi(sessionId = currentSessionId) {
    const request = userAbilityAPI.delete(`/session/${sessionId}`);
    currentSessionId = null;
    return request;
}

export function getChatToken(body) {
    return proxyAPI.post('/chatKey', body);
}
